<script setup>
import { ref, reactive, computed, onBeforeMount, onMounted, defineComponent, getCurrentInstance, onBeforeUnmount } from 'vue'
import { useRoute, useRouter, RouterLink, RouterView } from 'vue-router'
import { showToast } from 'vant';
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import "swiper/css/navigation";
import { Navigation, Mousewheel } from 'swiper/modules';
import copy from 'copy-to-clipboard'
import HomeView from './mobileView/HomeView.vue';
import RoleInfoViewMb from './mobileView/RoleInfoViewMb.vue';
import PayViewMb from './mobileView/PayViewMb.vue';
import UserInfoViewMb from './mobileView/UserInfoViewMb.vue';
import { userInfoStore, rewardListStore } from '@/stores/counter.js'
import { getReqData, loginAPI, getHomeConfigAPI, loginoutAPI, getCommunicationAPI, sendGiftCodeAPI } from '@/util/api'
import mystical from "@/util/mystical"

const route = useRoute()
const router = useRouter()
let { proxy } = getCurrentInstance()

const userStore = userInfoStore()
const rewardStore = rewardListStore()
const userInfo = computed(() => {
  return userStore.userInfo
})

const modules = ref([Navigation, Mousewheel])
const ElementSwiper = defineComponent(Swiper)
const ElementSwiperSlide = defineComponent(SwiperSlide)
const swiperInstance = ref();
const swiperIndex = ref(0)
const childRef = ref()
const childRef1 = ref()
const childRef3 = ref()
const childRef4 = ref()

const showNavList = ref(false)
const showLoginPop = ref(false)
let loginObj = ref({
  uname: '',
  upwd: ''
})
const navIndex = ref('')

const agree = ref(false)
let isWait = ref(false)
const timeOut1 = ref(null)
const count1 = ref(60)

const onSwiper = (swp) => {
  swiperInstance.value = swp
}
const switchSlide = (index) => {
  swiperInstance.value.slideTo(index, 500, false);
  swiperIndex.value = index
  showNavList.value = false
}
const onSlideChange = (index) => {
  console.log('【onSlideChange】', index.activeIndex)
  swiperIndex.value = index.activeIndex
  if (swiperIndex.value == 0) {
    childRef1.value.audioPlay()
  } else {
    childRef1.value.stopAudio()
  }
  if (swiperIndex.value == 1) {
    childRef.value.audioPlay()
  }
  if (swiperIndex.value == 2) {
    swiperInstance.value.allowTouchMove = false
  } else {
    swiperInstance.value.allowTouchMove = true
  }
  if ((swiperIndex.value == 2 || swiperIndex.value == 3) && !userInfo.value) {
    console.log('【前往充值界面没登陆】', userInfo.value);
    showLoginPop.value = true
  }
}
const needLogin = () => {
  showLoginPop.value = true
}
const configLogin = () => {
  if (!loginObj.value.uname) {
    showToast({ type: 'fail', message: '아이디를 입력해주세요.', className: 'toast-fail' })
    return
  }
  if (!loginObj.value.upwd) {
    showToast({ type: 'fail', message: '비밀번호를 입력해주세요.', className: 'toast-fail' })
    return
  }
  loginAPI(getReqData(loginObj.value)).then(res => {
    if (res.data.code == 0) {
      showToast({ type: 'success', message: res.data.msg, className: 'toast-success' })
      userStore.setUserInfo(res.data.data)
      localStorage.setItem(
        "2G19fZeORY8=",
        mystical.des_encrypt(JSON.stringify(res.data.data))
      );
      localStorage.setItem(
        "FiJISxKHfpo=",
        mystical.des_encrypt(res.data.data.token)
      );
      showLoginPop.value = false
      window.location.reload()
    } else {
      showToast({ type: 'fail', message: res.data.msg, className: 'toast-fail' })
    }
  }).catch(err => {
    console.log('[error]', err);
  })
}
const closeLoginPop = () => {
  showLoginPop.value = false
  if ((swiperIndex.value == 2 || swiperIndex.value == 3) && !userInfo.value) {
    swiperInstance.value.slideTo(0, 500, false);
  }
}
const toAppStor = () => {
  window.location.href = JSON.parse(localStorage.getItem('config-record')).download[1].value
}
const toGgStor = () => {
  window.location.href = JSON.parse(localStorage.getItem('config-record')).download[0].value
}
const toFb = () => {
  window.location.href = JSON.parse(localStorage.getItem('config-record')).download[2].value
}
const updateCommunication = () => {
  childRef1.value.getCommunication()
}

onBeforeMount(() => {
  if (localStorage.getItem("2G19fZeORY8=")) {
    userStore.setUserInfo(JSON.parse(mystical.des_decrypt(localStorage.getItem("2G19fZeORY8="))))
  }
})

onMounted(() => {

})
onBeforeUnmount(() => {

})
</script>

<template>
  <section class="home-box">
    <section class="meun-box">
      <aside
        style="display: flex; align-items: center; padding: 0.04rem 0.16rem; background: rgb(255 255 255 / 20%); border-radius: 6px; margin-right: 22px;">
        <img v-if="navIndex == '1'" src="@/assets/img/nav/navm0101a.png" alt=""
          style="height: 0.12rem; padding: 0.02rem 0rem;">
        <img v-else src="@/assets/img/nav/navm0101.png" alt="" @click="switchSlide(0)"
          style="height: 0.12rem; padding: 0.02rem 0rem;">
        <span
          style="display: block; width: 1.5px; height: 0.15rem; border-radius: 4px; background: rgb(75 123 167 / 65%); margin: 0px 7px;"></span>
        <img v-if="navIndex == '2'" src="@/assets/img/nav/navm0201a.png" alt=""
          style="height: 0.12rem; padding: 0.02rem 0rem;">
        <img v-else src="@/assets/img/nav/navm0201.png" alt="" @click="switchSlide(1)"
          style="height: 0.12rem; padding: 0.02rem 0rem;">
        <span
          style="display: block; width: 1.5px; height: 0.15rem; border-radius: 4px; background: rgb(75 123 167 / 65%); margin: 0px 7px;"></span>
        <img v-if="navIndex == '3'" src="@/assets/img/nav/navm0301a.png" alt=""
          style="height: 0.12rem; padding: 0.02rem 0rem;">
        <img v-else src="@/assets/img/nav/navm0301.png" alt="" @click="switchSlide(2)"
          style="height: 0.12rem; padding: 0.02rem 0rem;">
        <span
          style="display: block; width: 1.5px; height: 0.15rem; border-radius: 4px; background: rgb(75 123 167 / 65%); margin: 0px 7px;"></span>
        <img v-if="navIndex == '4'" src="@/assets/img/nav/navm0401a.png" alt=""
          style="height: 0.12rem; padding: 0.02rem 0rem;">
        <img v-else src="@/assets/img/nav/navm0401.png" alt="" @click="switchSlide(3)"
          style="height: 0.12rem; padding: 0.02rem 0rem;">
      </aside>
      <img src="@/assets/img/nav/meun-icon.png" alt="" @click="showNavList = true"
        style="height: 0.23rem; margin-right: 16px;">
    </section>
    <ElementSwiper class="disable-touch-move" @swiper="onSwiper" @slideChange="onSlideChange" :slides-per-view="1" :modules="modules"
      :space-between="0" :mousewheel="true" :direction="'vertical'"  style="width: 100%; height: 100%;">
      <ElementSwiperSlide>
        <HomeView ref="childRef1" @needLogin="needLogin" @goNextPage="switchSlide(1)" @goPayPage="switchSlide(2)"
          @goBinding="switchSlide(3)" />
      </ElementSwiperSlide>
      <ElementSwiperSlide>
        <RoleInfoViewMb ref="childRef" />
      </ElementSwiperSlide>
      <ElementSwiperSlide>
        <PayViewMb ref="childRef3" @needLogin="needLogin" />
      </ElementSwiperSlide>
      <ElementSwiperSlide>
        <UserInfoViewMb ref="childRef4" @updateCommunication="updateCommunication"/>
      </ElementSwiperSlide>
    </ElementSwiper>
    <section class="meun-list-box" v-show="showNavList">
      <img class="close-btn" src="@/assets/img/nav/close-icon.png" alt="" @click="showNavList = false">
      <section class="list-box">
        <aside class="list-item">
          <img src="@/assets/img/nav/navm01.png" alt="" @click="switchSlide(0)" style="height: 0.2rem;">
        </aside>
        <aside class="list-item">
          <img src="@/assets/img/nav/navm02.png" alt="" @click="switchSlide(1)" style="height: 0.2rem;">
        </aside>
        <aside class="list-item">
          <img src="@/assets/img/nav/navm03.png" alt="" @click="switchSlide(2)" style="height: 0.2rem;">
        </aside>
        <aside class="list-item">
          <img src="@/assets/img/nav/navm04.png" alt="" @click="switchSlide(3)" style="height: 0.2rem;">
        </aside>
      </section>
      <section style="display: flex; flex-direction: column; align-items: center;">
        <img src="@/assets/img/nav/fb-nav-icon.png" alt="" @click="toFb" style="margin-top: 0.5rem; height: 0.48rem;">
        <aside style="display: flex; justify-content: center; margin-top: 0.32rem;">
          <img src="@/assets/img/nav/as-icon.png" alt="" @click="toAppStor"
            style="height: 0.3rem; margin-right: 20px; border: 1px solid #565656; border-radius: 5px;">
          <img src="@/assets/img/nav/ad-icon.png" alt="" @click="toGgStor"
            style="height: 0.3rem; margin-left: 20px; border: 1px solid #565656; border-radius: 5px;">
        </aside>
      </section>
    </section>
    <section class="mask-box" v-show="showLoginPop">
      <section class="login-box">
        <aside
          style="display: flex; justify-content: space-between; align-items: center; height: 32px; width: 100%;">
          <span style="font-size: 16px; color: #ffffff; margin-left: 12px;">게임 계정 로그인</span>
          <img src="@/assets/img/nav/close-icon.png" alt="" @click="closeLoginPop()" style="height: 0.24rem; margin-right: 12px;">
        </aside>
        <aside class="input-box" style="margin-top: 22px;">
          <img class="icon" src="@/assets/img/nav/nm-icon.png" alt="">
          <input type="text" v-model="loginObj.uname" placeholder="아이디를 입력해주세요">
        </aside>
        <aside class="input-box" style="margin-top: 18px;">
          <img class="icon" src="@/assets/img/nav/mm-icon.png" alt="">
          <input type="password" name="" id="" v-model="loginObj.upwd" placeholder="비밀번호를 입력해주세요">
        </aside>
        <img src="@/assets/img/nav/login-btn.png" alt="" @click="configLogin" style="height: 42px; margin-top: 50px;">
        <aside style="display: flex; justify-content: space-between; margin-top: 40px; width: 316px;">
          <button @click="showLoginPop = false"
            style="font-size: 12px; color: rgb(90, 131, 208); border: none; background: none;">건너뛰기</button>
          <button @click="toFb" style="font-size: 12px; color: rgb(90, 131, 208); border: none; background: none;">비밀번호
            찾기</button>
        </aside>
      </section>
    </section>
  </section>
</template>

<style scoped>
.home-box {
  width: 100%;
  height: 100vh;
  position: relative;
}

.shop-box {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.meun-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 8;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0.15rem 0rem;
  background: url('../assets/img/nav/meu-bac.png') no-repeat;
  background-size: 100% 100%;
}

.meun-list-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9;
  background: rgb(0 0 0 / 75%);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.close-btn {
  position: absolute;
  top: 0.16rem;
  right: 0.16rem;
  height: 0.24rem;
}

.list-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0.5rem 37px 0px;
  width: 80%;
}

.list-box .list-item {
  border-bottom: 2px solid rgb(75 123 167 / 65%);
  padding: 0.28rem 0rem 0.26rem;
  width: 100%;
  display: flex;
  justify-content: center;
}

.mask-box {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgb(0 0 0 / 80%);
  z-index: 99;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.mask-content {
  width: 354px;
  height: 294px;
  background: url('../assets/img/nav/login-bac.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.text-sys2 {
  font-size: 14px;
  font-weight: bolder;
  color: #9d4f23;
  /* text-shadow: -0.2px -0.2px 0 #fff1d6, 0.2px -0.2px 0 #fff1d6, -0.2px 0.2px 0 #fff1d6, 0.2px 0.2px 0 #fff1d6; */
}

.text-sys3 {
  font-size: 14px;
  /* font-weight: bolder; */
  color: #443421;
  /* text-shadow: -0.2px -0.2px 0 #fff1d6, 0.2px -0.2px 0 #fff1d6, -0.2px 0.2px 0 #fff1d6, 0.2px 0.2px 0 #fff1d6; */
}

.out-box {
  background: rgb(139, 173, 216);
  position: absolute;
  right: 12px;
  top: 0.7rem;
  height: 20px;
  font-size: 12px;
  font-weight: bold;
  padding: 4px 6px;
  border-radius: 6px;
  color: rgb(67, 116, 167);
  display: flex;
  align-items: center;
}

.out-btn {
  border-radius: 4px;
  border: none;
  background: none;
  color: #ffffff;
  font-size: 12px;
  padding: 2px 3px;
}

.videoBox {
  object-fit: cover;
  z-index: 0;
}

.login-box {
  width: 350px;
  height: 312px;
  background: url('../assets/img/nav/login-bac.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.input-box {
  width: 326px;
  height: 38px;
  display: flex;
  position: relative;
}

.input-box input {
  display: block;
  width: 264px;
  padding: 0px 6px 0px 54px;
  font-size: 13px;
  border: 1px solid rgb(196, 132, 94);
  border-radius: 12px;
}

input::placeholder {
  color: #cdcdcd;
}

.input-box .icon {
  position: absolute;
  left: 18px;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
}
.disable-touch-move {
  touch-action: none; /* 这将阻止所有触摸动作 */
}
</style>
